import { useFormikContext } from "formik";
import { ParentProfileFormType } from "../schemas";
import { StudentSection, StudentSectionProps } from "./StudentSection";

// Create-parent usage of StudentSection: supplies the live parent name from the
// surrounding Formik so a new student chip reads "Child of {parent}".
export function ParentStudentSection(
  props: Omit<StudentSectionProps, "parentName">
) {
  const { values } = useFormikContext<ParentProfileFormType>();
  const parentName = [values.first_name, values.last_name]
    .filter(Boolean)
    .join(" ");
  return <StudentSection {...props} parentName={parentName} />;
}
